<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">

    <section id="header">
      <h1 class="h1Header">EDITANDO DETALLE</h1>
    </section>
    <form [formGroup]="editSliderForm" (ngSubmit)="saveChanges(editSliderForm.value)">
      <mat-card>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="100">
            <mat-form-field appearance="outline">
              <mat-label>Título</mat-label>
              <input type="text" matInput formControlName="titulo">
              <mat-hint>Etiqueta básica de HTML permitida</mat-hint>
              <mat-error *ngIf="editSliderForm.controls['titulo'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="60">
            <mat-form-field appearance="outline">
              <ngx-mat-file-input formControlName="imagen" accept=".png, .jpeg, .jpg">
              </ngx-mat-file-input>
            </mat-form-field>
          </div>
          <div fxFlex="40">
            <mat-form-field appearance="outline">
              <mat-label>Orden No.</mat-label>
              <input type="text" matInput formControlName="nroOrden">
              <mat-error *ngIf="editSliderForm.controls['nroOrden'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="0.5rem">
          <div fxFlex="40" fxLayoutGap="0.5rem">
            <img class="image-preview" [src]="DsImage" />
          </div>
        </div>
      </mat-card>
      <br>
      <div fxLayout="row" fxLayoutAlign="center center">
        <button type="submit" mat-raised-button [disabled]="!editSliderForm.valid" class="save-changes">GUARDAR CAMBIOS</button>
        <button routerLink="/start-slider" mat-raised-button class="cancel-changes">CANCELAR</button>
      </div>
    </form>
  </div>
</div>
